"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactLoadableLoading = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ErrorState_1 = require("../ErrorState");
const LoadingState_1 = require("../LoadingState");
/**
 * Loading component used in react-loadable library
 * @param props
 */
const ReactLoadableLoading = (props) => {
    if (props.error) {
        return <ErrorState_1.ErrorState error={props.error} retry={props.retry}/>;
    }
    else if (props.isLoading && props.pastDelay) {
        return <LoadingState_1.LoadingState timedOut={props.timedOut} retry={props.retry}/>;
    }
    else {
        return null;
    }
};
exports.ReactLoadableLoading = ReactLoadableLoading;
exports.ReactLoadableLoading.displayName = 'ReactLoadableLoading';
